import React from "react";
import {
  Property,
  PropertyValue,
} from "features/BuildingProductEditor/ProductEditorStore";
import DropdownList, { Option } from "./DropdownList";
import SelectedItem from "./SelectedItem";
import { useTranslation } from "react-i18next";
import useSelect from "./useSelect";

const Select = ({
  property,
  onChange,
}: {
  property: Property;
  onChange: (value: PropertyValue) => void;
}) => {
  const { t } = useTranslation();

  const handleRemoveOption = async (item: Option | null) => {
    if (item === null) return;
    const foundedItem = options.find((rec) => rec.id === item.id);
    if (property.value === foundedItem?.name) onChange(undefined);
    const updatedList = options.filter((rec) => rec.id !== item.id);
    await updateOptions(updatedList);
  };

  const {
    removeConfirmPopup,
    options,
    updateOptions,
    handleSearchTerm,
    onClickRemoveOption,
  } = useSelect(property, handleRemoveOption);

  const handleChangeValue = (item: Option) => {
    if (property?.value != item.name) onChange(item.name);
    if (item?.id === "search_term") handleSearchTerm(item);
  };

  const selectedItem = options.find((rec) => rec.id === property?.value)?.name;
  return (
    <div className="w-full flex bg-white min-h-full">
      <DropdownList
        containerClassName="w-full"
        options={options}
        onChangeItems={handleChangeValue}
        selectedItems={selectedItem ? [selectedItem] : []}
        onRemoveOption={onClickRemoveOption}
        placeholder={property?.value ? "" : t("productEditor.empty")}
      >
        {property?.value ? (
          <SelectedItem
            rec={String(property.value)}
            removeItem={() => onChange(undefined)}
          />
        ) : null}
      </DropdownList>
      {removeConfirmPopup()}
    </div>
  );
};

export default Select;
